import { createSelector } from 'reselect';
import { getRcoms } from '../utils';

export const multicityStateSelector = state => state.multicity;

export const selectedTabIndexSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.selectedTabIndex
);

export const selectedLegIndexSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.selectedLegIndex
);

export const searchStringSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.searchString
);
export const searchStringObjectSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.searchStringObject
);
export const searchParamSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.searchParams
);

export const combinationFlightDataSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.combinationFlightData
);
export const splitFlightDataSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.splitFlightData
);

export const selectedCombinationSortSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.selectedCombinationSort
);
export const selectedSplitSortSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.selectedSplitSort
);
export const selectedSplitFiltersSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.selectedSplitFilters
);
export const splitDisplayListSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.splitDisplayList
);

export const selectedSplitFlightsSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.selectedSplitFlights
);

export const selectedCombinationFlightSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.selectedCombinationFlight
);

export const commonRulesSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.commonRules
);

export const flavourSelector = createSelector(
  multicityStateSelector,
  multicity => multicity.flavour
);

export const repriceRequestMulticitySelector = createSelector(
  [
    selectedCombinationFlightSelector,
    combinationFlightDataSelector,
    selectedSplitFlightsSelector,
    splitFlightDataSelector,
    selectedTabIndexSelector
  ],
  (
    selectedCombinationFlight,
    combinationFlightData,
    selectedSplitFlights,
    splitFlightData,
    selectedTabIndex
  ) => {
    const query = selectedTabIndex === 0 ? combinationFlightData?.query : splitFlightData?.query;
    const rcoms = getRcoms(
      selectedTabIndex === 0 ? selectedCombinationFlight : selectedSplitFlights
    );
    return {
      v: 1.6,
      flavour: 'DESKTOP',
      rid: `${query?.search_id}`,
      rcoms: JSON.stringify(rcoms)
    };
  }
);

export const searchContextDataSelector = createSelector(
  [
    splitFlightDataSelector,
    combinationFlightDataSelector,
    searchParamSelector,
    selectedTabIndexSelector,
    flavourSelector
  ],
  (splitFlightData, combinationFlightData, searchParam, selectedTabIndex, flavour) => {
    const journey_type = 'MC';
    const details = [];
    const { fareType, pax, flightClass, sources, destinations, departureDates } = searchParam;
    const paxArray = pax.split('-');
    const [adult, child, infant] = paxArray;
    const { query } = selectedTabIndex === 1 ? splitFlightData : combinationFlightData;
    const sectorLen = sources.length;
    for (let i = 0; i < sectorLen; i++) {
      const src = sources[i];
      const srcDetails = query[src];
      const des = destinations[i];
      const desDetails = query[des];
      const traveldate = parseInt(departureDates[i], 10);
      const travelType =
        srcDetails.cc === 'IN' && desDetails.cc === 'IN' ? 'domestic' : 'international';
      const sectorDetail = {
        source_code: src,
        source_country: srcDetails.cc,
        destination_code: des,
        destination_country: desDetails.cc,
        sector_type: travelType,
        traveldate,
        arr_traveldate: ''
      };
      details.push(sectorDetail);
    }
    const searchContext = {
      journey_type,
      fare_type: fareType,
      total_adults: adult,
      total_children: child,
      total_infants: infant,
      total_pax: parseInt(adult, 10) + parseInt(child, 10) + parseInt(infant, 10),
      travel_class: flightClass,
      details
    };
    const flightSearchData = {
      passengers: {
        adult,
        child,
        infant
      },
      flightClass: { value: flightClass },
      source: query[sources[0]],
      destination: query[destinations[destinations.length - 1]],
      departure: {},
      arrival: null,
      journeyType: 'MC',
      travelType: query.isIntl ? 'international' : 'domestic',
      selectedFareIdentifier: fareType,
      flavour: flavour
    };
    return { searchContext, flightSearchData };
  }
);
